import z from 'zod';
import { ThemeMode } from '../common/enums';
import { DBUserSharedSettingsSchema } from './schemas';

export const DEFAULT_USER_SETTINGS: z.infer<typeof DBUserSharedSettingsSchema> = {
  themeMode: ThemeMode.Light,
};
